import React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import FlashlightOnIcon from "@mui/icons-material/FlashlightOn";
import FlashlightOffIcon from "@mui/icons-material/FlashlightOff";

export default function TorchButton({ torchOn, onClick }) {
  return (
    <Box
      position="fixed"
      top={90}
      right={25}
      zIndex={99}
    >
      <IconButton
        onClick={onClick}
        sx={{
          bgcolor: "rgba(0, 0, 0, 0.5)",
          color: torchOn ? "warning.main" : "white",
          "&:hover": {
            bgcolor: "rgba(0, 0, 0, 0.7)",
          },
        }}
      >
        {torchOn ? <FlashlightOnIcon /> : <FlashlightOffIcon />}
      </IconButton>
    </Box>
  );
}
